const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

class RecaptchaService {
  constructor() {
    this.isReady = false;
    this.scriptEl = null;
  }

  init() {
    return new Promise((resolve) => {
      if (this.isReady) { resolve(true); return; }

      if (!SITE_KEY) {
        console.error('reCAPTCHA site key not configured (REACT_APP_RECAPTCHA_SITE_KEY)');
        resolve(false);
        return;
      }

      // Inject script dynamically if not already present
      if (!document.querySelector('script[src*="recaptcha/enterprise"]')) {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${SITE_KEY}`;
        script.async = true;
        this.scriptEl = script;
        document.head.appendChild(script);
      }

      const maxAttempts = 50;
      let attempts = 0;

      const wait = () => {
        if (window.grecaptcha?.enterprise) {
          window.grecaptcha.enterprise.ready(() => {
            this.isReady = true;
            resolve(true);
          });
        } else if (attempts++ < maxAttempts) {
          setTimeout(wait, 100);
        } else {
          console.error('reCAPTCHA Enterprise failed to load within timeout');
          resolve(false);
        }
      };

      wait();
    });
  }

  cleanup() {
    // Remove injected script
    if (this.scriptEl) {
      this.scriptEl.remove();
      this.scriptEl = null;
    }
    // Remove the reCAPTCHA badge from the DOM
    document.querySelectorAll('.grecaptcha-badge').forEach(el => el.remove());
    this.isReady = false;
  }

  async executeToken(action = 'submit') {
    const ready = await this.init();
    if (!ready || !window.grecaptcha?.enterprise) return null;

    try {
      return await new Promise((resolve, reject) => {
        window.grecaptcha.enterprise.ready(() => {
          window.grecaptcha.enterprise.execute(SITE_KEY, { action }).then(resolve).catch(reject);
        });
      });
    } catch (error) {
      console.error('reCAPTCHA execution error:', error);
      return null;
    }
  }
}

const recaptchaService = new RecaptchaService();
export default recaptchaService;
